var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    transform: "rotate(0,12,12) translate(2.00061986924097,2) scale(0.624980778093249,0.624980778093249)  ",
    fill: "#000000",
    d: "M14.221988,30.222944L31.999001,30.222944 31.999001,31.999946 14.221988,31.999946z M28.436571,10.48223L28.442999,10.488657C28.440233,10.488657,28.438292,10.487832,28.437151,10.48621z M19.554997,5.5115979L26.31098,12.267675 6.7559831,32.000983 0,32.000983 0,25.422889 0,25.421851C-2.7426722E-08,25.421851,19.733006,5.6886022,19.554997,5.5115979z M26.132246,0C26.576742,0,27.020987,0.17750798,27.375983,0.53252377L31.465981,4.6226084C32.176003,5.3345935 32.176003,6.4005873 31.465981,7.1115959 31.465981,7.1115959 28.462872,10.280889 28.436098,10.47897L28.436571,10.48223 21.686987,3.7325809 24.886999,0.53252377C25.243002,0.17750798,25.68775,0,26.132246,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a45228787a50a3db2aa6d36ca571784d.svg";
export { ForwardRef as ReactComponent };